<div class="renewals-container">

<!-- Added by amisha on 2026-08-24 to enable configured fixed widths for the Renewals Janus table.
     Reason: sorting must not resize columns when renewal values change length, and long values should truncate in place. -->
<!-- Updated by Amisha on 2026-09-21.
     Reason: Renewals is a direct page, so its mobile inline-expansion header should not include the Department route shell. -->
<wm-common-table class="renewals-common-table" [columns]="columns" [data]="data" tableType="Staff" [serverSidePagination]="serverSidePagination"
  [fixedColumnWidths]="true"
  mobileInlineExpansionParentTitle="Renewals"
  [currentPage]="currentPage" [totalPages]="totalPages" [pageSize]="pageSize" [isLoading]="isLoading"
  [fixedPagination]="true" [enableTableScroll]="true"
  [showRowsPerPage]="true"
  [showTotalRecords]="true" [totalRecords]="totalRecords"
  [pageSizeStorageKey]="pageSizeStorageKey"
  (rowsPerPageChange)="handleRowsPerPageChange($event)"
  (pageChange)="handlePageChange($event)" expansionMode="inline" expandOn="cell" [expandedComponent]="expandedComponent"
  [expandedComponentInputs]="expandedComponentInputs" (sortChanged)="sortChanged.emit($event)"
  (displayedColumnsChange)="displayedColumnsChange.emit($event)"
  [sortField]="sortField" [sortDescending]="sortDescending">
</wm-common-table>

</div>
<!-- code changes by Krutika for disable/enable/delete modal-->
<wm-common-confirmation-modal
  [data]="modalData"
  (onYesClick)="confirmAction()"
  (onNoClick)="cancelAction()"
  (onOkClick)="closeModal()"
  (onCloseClick)="closeModal()"
  [isApplicantMobileview]="true">
</wm-common-confirmation-modal>
<!-- End code changes by Krutika -->
